import Accordion from 'components/Accordion';
import Field from 'components/Form/Field';
import KeyValue from 'components/Layout/KeyValue';
import TooltipIcon from 'components/Tooltip/TooltipIcon';
import Value from 'components/Value';
import {SupersendContact} from 'pages/History/SendingOrders/Details/types';
import {FC} from 'react';
import {t} from 'ttag';

type SendViaClientinboxProps = {
    isSelected: boolean;
    usersForSendingList?: SupersendContact[];
};

const SendViaClientinbox: FC<SendViaClientinboxProps> = ({
    isSelected,
    usersForSendingList,
}) => {
    if (!isSelected) {
        return null;
    }

    return (
        <Accordion
            header={
                <div className="flex items-center gap-2">
                    <h2 className="m-0 flex items-center gap-2 p-0">
                        {t`Send via Client Inbox`}
                    </h2>
                    <TooltipIcon
                        href="https://help.makeleaps.jp/ja/articles/8687198-makeleapsのシステムから書類を送付する方法#h_bc10350fef"
                        message={t`What is "Send via Client Inbox"?`}
                        onClick={(e) => e.stopPropagation()}
                        size="base"
                    />
                </div>
            }
            hideDividerIfLast={true}
            id="send-via-client-inbox"
            isOpenByDefault={true}
        >
            <KeyValue keyWidth={10}>
                <Field
                    label={t`Send to`}
                    tooltip={{
                        message: t`The email addresses which receive activity notifications and can access the Client Inbox`,
                    }}
                    type="value"
                >
                    {usersForSendingList ? (
                        <Value
                            value={{
                                type: 'tags',
                                value: usersForSendingList.map((recipient) => ({
                                    color: 'blue',
                                    label: recipient.email || '-',
                                    tooltip: recipient.email,
                                })),
                            }}
                        />
                    ) : (
                        <Value
                            value={{
                                type: 'string',
                                value: t`No Client Inbox Users set.`,
                            }}
                        />
                    )}
                </Field>
            </KeyValue>
        </Accordion>
    );
};
export default SendViaClientinbox;
